import { DashboardEmbedPanel } from '@/components/dashboard/DashboardPanels';
import { DashboardHowItWorksLink } from '@/pages/dashboard/DashboardHelpPage';

export default function DashboardWidgetPage() {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold">Chat widget</h2>
        <p className="text-sm text-muted-foreground">
          Embed the assistant on your website.{' '}
          <DashboardHowItWorksLink hash="get-started" />
        </p>
      </div>
      <DashboardEmbedPanel />
    </div>
  );
}
